import { useMutation } from '@tanstack/react-query';
import { getAxios } from '../../lib/axios';
import { ApiEndpoints } from '../../constants/endpoints/apiEndpoints.ts';

export function useAddTutorialMutation(userId: string) {
  return useMutation({
    mutationKey: [userId, 'addTutorial'],
    mutationFn: async (tutorialName: string) => {
      return (await getAxios().post(ApiEndpoints.userProfile.addTutorial(userId, tutorialName))).data;
    }
  });
}
